import { V2Badge, V2Card } from '@sakhtar/design-system/react';
import { YarEmpty, YarRoom, YarRoomShell } from './YarRoom.js';
import { YarInactiveNotice, useModuleYar } from './moduleYar.js';
import './yar.css';

/**
 * Module assistant tab. Connects each module character to its dedicated
 * quote/run analytical YarRoom.
 */
export function ModuleAssistantPage({ moduleId }: { readonly moduleId: string }) {
  const state = useModuleYar(moduleId);
  const { yar, wiring, active } = state;
  if (!yar) return null;

  return (
    <div
      className="yar-page"
      style={{ ['--yar-main' as string]: yar.main, ['--yar-light' as string]: yar.light }}
    >
      <V2Card className="yar-page__head">
        <img className="yar-page__avatar" src={yar.image} alt="" />
        <div style={{ minWidth: 0, marginInlineEnd: 'auto' }}>
          <h2 className="yar-page__title">{yar.name}</h2>
          <p className="yar-page__sub">دستیار هوشمند {yar.moduleLabel}</p>
        </div>
        <V2Badge tone={active ? 'success' : 'warn'}>{active ? 'فعال' : 'غیرفعال'}</V2Badge>
      </V2Card>

      <V2Card>
        {active && wiring ? (
          <YarRoom
            assistantKey={wiring.assistantKey}
            tool={wiring.tool}
            domain={wiring.domain}
            yarName={yar.name}
            avatar={yar.image}
            suggestions={wiring.suggestions}
          />
        ) : (
          <>
            <div className="yar-page__notice">
              <YarInactiveNotice state={state} />
            </div>
            <YarRoomShell disabled note={null} yarName={yar.name}>
              <YarEmpty yarName={yar.name} avatar={yar.image} />
            </YarRoomShell>
          </>
        )}
      </V2Card>
    </div>
  );
}
